// extracted by mini-css-extract-plugin
export default {"infoItem":"item_infoItem__35UN4","infoItemTitle":"item_infoItemTitle__1X7b4"};